import React from 'react';
import { motion } from 'framer-motion';
import { HiDocumentText, HiSparkles } from 'react-icons/hi2';

const TABS = [
  { id: 'all', label: 'All' },
  { id: 'mine', label: 'Mine' },
  { id: 'shared', label: 'Shared' },
  { id: 'public', label: 'Public' },
  { id: 'byRole', label: 'By Role' },
  { id: 'byUser', label: 'By User' },
];

export default function DocumentsHeader({ count, activeTab, setActiveTab, isClient = false }) {
  const tabsToShow = isClient ? TABS.filter(t => ['all', 'mine', 'shared'].includes(t.id)) : TABS;

  return (
    <div className="border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white px-4 py-4 sm:px-6 sm:py-5 lg:px-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3 sm:gap-4">
          <motion.div
            initial={{ scale: 0, rotate: -180 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ type: 'spring', stiffness: 200 }}
            className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-blue-600 text-white shadow-lg shadow-blue-500/30 sm:h-11 sm:w-11"
          >
            <HiDocumentText className="h-5 w-5 sm:h-6 sm:w-6" />
          </motion.div>
          <div className="min-w-0">
            <h2 className="text-lg font-bold text-black sm:text-xl">Documents</h2>
            <motion.p
              key={count}
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="text-sm font-medium text-gray-600"
            >
              {count > 0 ? (
                <>
                  <span className="font-bold text-blue-600">{count}</span> document
                  {count !== 1 ? 's' : ''} found
                </>
              ) : (
                'No documents found'
              )}
            </motion.p>
          </div>
        </div>
        {count > 0 && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, type: 'spring' }}
            className="hidden items-center gap-2 rounded-lg bg-blue-50 px-3 py-1.5 sm:flex"
          >
            <HiSparkles className="h-4 w-4 text-blue-600" />
            <span className="text-xs font-semibold text-blue-600">Active</span>
          </motion.div>
        )}
      </div>

      {setActiveTab && tabsToShow.length > 1 && (
        <div className="scrollbar-none mt-4 overflow-x-auto pb-2 sm:mt-5 sm:pb-0">
          <div className="flex gap-2">
            {tabsToShow.map(tab => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`whitespace-nowrap rounded-lg px-4 py-2 text-sm font-semibold transition-all ${
                  activeTab === tab.id
                    ? 'bg-blue-600 text-white shadow-md shadow-blue-500/20'
                    : 'bg-white text-gray-600 ring-1 ring-gray-200 hover:bg-gray-50 hover:text-blue-600 hover:ring-blue-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
